import { jsx } from '@emotion/react';
import { clsx } from 'clsx';
import { Section, Header } from 'react-aria-components';

const header = "_header_139rn_1";
const section = "_section_139rn_6";
const styles = {
	header: header,
	section: section
};

const SelectGroup = ({ children, className, label }) => {
  return jsx(
    Section,
    { className: clsx(className, styles.section), "data-zds": true },
    jsx(Header, { className: styles.header, "data-zds": true }, label),
    children
  );
};

export { SelectGroup };
//# sourceMappingURL=SelectGroup.es.js.map
